import { Button, Grid, Stack, Typography } from "@mui/material";
import {
  CircularLoading,
  LargeContentBox,
  PrimaryButton,
} from "../../components/common";
import { PrivateMainLayout } from "../../components/layout";

import { PatientData } from "./components/PatientData";

import { ArrowBack, Assignment, PlayArrow } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ScreenMobile } from "../../components/common/ScreenMobile";
import { useClinicalRegisterContext } from "../../contexts/ClinicalRegisterContext";
import { useSessionContext } from "../../contexts/SessionContext";
import { BundlePatientSummary } from "../../services/fhir";
import { GetAppointment } from "../../services/fhir/appointment/GetAppointment";
import { HTTPResponseStatus } from "../../utils/enum";
import { PatientSummary } from "./components/PatientSummary";
import { PageHeader } from "@/components/common/PageHeader";

export function EHRRecords() {
  const { id } = useParams();
  const { state } = useLocation();
  const { user } = useSessionContext();
  const { verifyEncounter } = useClinicalRegisterContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [summaryData, setSummaryData] = useState();
  const [refetch, setRefetch] = useState<boolean>(false);
  // Estado para armazenar os dados do appointment e verificar o status
  const [appointmentData, setAppointmentData] = useState<any>(null);

  const verifyRoute = id === "myrecords" ? user?.username : undefined;
  
  // Verificar se pode iniciar o atendimento (apenas quando status for "booked")
  const canStartAppointment = state?.appointment && appointmentData?.status === "booked";

  useEffect(() => {
    async function GetBundle() {
      setLoading(true);
      try {
        const bundleResponse = await BundlePatientSummary({
          identifier: state?.patientId || verifyRoute,
          purposeofuse: state?.purpose || "Atendimento",
        });

        if (bundleResponse.status === HTTPResponseStatus.Forbidden) {
          navigate("/");
          toast.warn("Verifique as opções de consentimento");
        }
        setSummaryData(bundleResponse);
      } catch (err) {
        console.log("PatientSummary error:", err);
      } finally {
        setLoading(false);
      }
    }

    // Buscar os dados do appointment para verificar o status
    async function FetchAppointment() {
      if (state?.appointment) {
        try {
          const appointmentResponse = await GetAppointment({
            ehrrunner: state?.patientId,
            _id: state.appointment?.id,
          });
          // Se retornar um recurso direto (não Bundle), armazena diretamente
          // Se retornar um Bundle, pega o primeiro recurso
          const appointment = appointmentResponse?.resourceType === "Appointment" 
            ? appointmentResponse 
            : appointmentResponse?.entry?.[0]?.resource;
          
          setAppointmentData(appointment);
        } catch (err) {
          console.log("GetAppointment error:", err);
          // Em caso de erro, não exibe o botão
          setAppointmentData(null);
        }
      }
    }

    if (state?.patientId || verifyRoute) GetBundle();
    FetchAppointment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch, state?.patientId, navigate, user]);

  return (
    <>
      <LargeContentBox>
        <Grid container rowSpacing={3} columnSpacing={6}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <PageHeader
              title="Sumário de saúde"
              icon={Assignment}
              action={
                canStartAppointment && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () =>
                      await verifyEncounter(state?.appointment)
                    }
                    startIcon={<PlayArrow />}
                  >
                    Iniciar atendimento
                  </Button>
                )
              }
            />

            <Grid
              container
              direction="row"
              maxWidth={{
                xs: `${window.innerWidth - 50}px`,
                sm: "fit-content",
              }}
              rowSpacing={3}
              columnSpacing={3}
            >
              <PatientData
                patientId={state?.patientId || verifyRoute}
                summaryData={summaryData}
              />

              <Grid item xs={12}>
                {loading ? (
                  <Stack
                    mt={4}
                    sx={{ minHeight: "200px", justifyContent: "center" }}
                  >
                    <CircularLoading />
                  </Stack>
                ) : (
                  <PatientSummary
                    summary={summaryData}
                    setRefetch={setRefetch}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          rowSpacing={3}
          columnSpacing={3}
          paddingTop={4}
          justifyContent="space-between"
        >
          <Grid item>
            {" "}
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBack />}
            >
              Voltar
            </Button>{" "}
          </Grid>
          <Grid item>
            {canStartAppointment && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () =>
                    await verifyEncounter(state?.appointment)
                  }
                  startIcon={<PlayArrow />}
                >
                  Iniciar atendimento
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </LargeContentBox>
    </>
  );
}
